import * as Yup from "yup"

export const FIELDS_NAME = {
   TRAILER_TYPE: "trailerType",
   MODEL_NAME: "model",
   SIZE: "size",
}

export const initialValues = {
   [FIELDS_NAME.TRAILER_TYPE]: "",
   [FIELDS_NAME.MODEL_NAME]: "",
   [FIELDS_NAME.SIZE]: [],
}

export const validationSchema = Yup.object({
   [FIELDS_NAME.SIZE]: Yup.array()
      .min(1, "At least one size must be selected")
      .required("Select size"),
   [FIELDS_NAME.TRAILER_TYPE]: Yup.object()
      .required("Select trailer type")
      .nullable("Select trailer type")
      .optional(),
   [FIELDS_NAME.MODEL_NAME]: Yup.object()
      .required("Select trailer model")
      .nullable("Select trailer model"),
})
